<template>
  <div id="app">
    <v-snackbar bottom right :value="updateExists" :timeout="-1" color="primary">
      Borrar cache
      <v-btn text @click="refreshApp">
        Update
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbar.show"
      :multi-line="snackbar['multi-line']"
      :timeout="snackbar.timeout"
      :top="snackbar.top"
      :right="snackbar.right"
      :left="snackbar.left"
      :color="snackbar.color">
      <div style="font-family: Roboto,sans-serif;color:black" :class="snackbar.class || ''">
        <v-icon v-if="snackbar.clearable" @click="snackbar.show = false" style="color:black;float: right">close</v-icon>
        <v-icon v-if="snackbar.icon">{{snackbar.icon}}</v-icon>
        <span>{{snackbar.message}}</span>
      </div>
    </v-snackbar>

    <!-- Requests -->
    <v-snackbar
      v-model="peendingRequest.length"
      :timeout="-1"
      :top="true"
      color="#ffffff"
      class="RqSnackbar"
      :right="true">
      <ul class="snackRS">
        <li v-for="(v, k) in peendingRequest" :key="k" :class="snackbar.class || ''">
          <v-progress-circular v-if="v.status === 'getting'" indeterminate color="primary" class="prg-2"/>
          <v-icon v-else>{{icons[v.status]}}</v-icon>
          <span>Obteniendo {{v.message}}</span>
        </li>
      </ul>
    </v-snackbar>

    <v-snackbar :value="true" top :color="progress.color" :timeout="-1" v-model="progress.show" multi-line>
      <div style="font-family: Roboto,sans-serif;color:black;padding-top:5px;width:100%"> 
        <div style="text-align:center">
          <v-icon>warning</v-icon>
          <span>
            {{progress.message}}
          </span>
        </div>
        <v-progress-linear color="primary" indeterminate striped rounded height="3"></v-progress-linear>
      </div>
    </v-snackbar>

    <v-snackbar :value="true" top :color="progress.color" :timeout="-1" v-if="!isOnline">
      <div style="font-family: Roboto,sans-serif;color:black;width:100%"> 
        <div style="text-align:center">
          <v-icon class="pulse_warning">warning</v-icon>
          <span> <b> Sin conexión </b> </span>
          <v-icon class="pulse_warning">warning</v-icon>
        </div>
      </div>
    </v-snackbar>
    <div id="devMode" v-if="devMode && showDevBar">
      <v-icon>developer_mode</v-icon>
      <span> Entorno de prueba</span>
      <v-icon class="float-r" color="black" @click="showDevBar = false">cancel</v-icon>
    </div>
    <component :is='layout'></component>

    <v-dialog v-model="incompleteDialog" :width="'50%'" @click:outside="incompleteClose">
			<v-card class="fullHeight pa-20">
        <div style="margin-bottom: 30px">
          <h2 class="dialogTitle">Falta información</h2>
          <!-- <v-icon class="closeDialog" v-on:click="incompleteClose">close</v-icon> -->
        </div>
        <fs1-div class="textAlignLeft">
          <ul>
            <li v-for="(v,i) in incompleteItems" :key="i">
              {{v}}
            </li>
          </ul>
        </fs1-div>
        <br>
				<div style="text-align: center; margin-top: 30px">
					<v-btn color="primary"  @click="incompleteClose" class="ma-4">
						<span>Aceptar</span>
					</v-btn>
				</div>
			</v-card>
    </v-dialog>
  </div>
</template>

<script>
const defaultLayout = 'default';
import { isDev } from './config';
import update from '@/update.js';

export default {
  mixins: [update],
  name: 'app',
  data() {
    return {
      icons: {
        getting: 'get_app',
        error: 'cancel',
        success: 'done',
      },
      showDevBar: true,
      incompleteDialog:false,
    };
  },
  computed: {
    incompleteItems() {return this.$store.getters.incompleteItems},
    devMode() { return isDev(); },
    layout()   { return `${this.$route.meta.layout || defaultLayout}-layout`; },
    snackbar() { return this.$store.getters.snackbar },
    progress() { return this.$store.getters.progress },
    requestStatus() { return this.$store.getters.requestStatus },
    peendingRequest() {
      return this.requestStatus
        .filter(f => f.status === 'getting' || f.ticking);
    },
  },
  watch:{
    incompleteItems(v){ this.incompleteDialog = !!v.length }
  },
  mounted() { this.$vuetify.clientHeight -= 0.1 },
  methods:{
    incompleteClose(){
      this.$store.dispatch('set',{key:'incompleteItems', val:[]});
    }
  },
};
</script>
<style>
 .theme--dark.secondary {
    color: black !important;
    background-color: #bfbfbf;
  }
.theme--dark.v-card,
.theme--dark.v-datatable .v-datatable__actions {
  background-color: #242424 !important;
}
.theme--dark .valueContainer,
.theme--dark .label{
  color: white !important;
}

</style>
<style scoped>
  .snack_success i{ color: green; }
  .snack_error i { color: red; }
  .snack_warning i { color: darkgoldenrod; }
  #devMode {
    background-color: grey;
    width: 100%;
    opacity: 0.4;
    height: 30px;
    font-size: 18px;
    text-align: center;
    color: white;
    line-height: 30px;
    font-weight: bold;
    font-family: Roboto,sans-serif;
    position: fixed;
    top: 0;
    z-index: 100000;
    /* top: 68px; */
  }
  .snackRS{
    color: black;
    list-style: none;
  }
  .snackRS i.done{ color: green; }
  .snackRS i.cancel{ color: red; }
  .prg-2 {
    height: 24px !important;
    width: 18px !important;
    margin-right: 3px !important;
    vertical-align: bottom;
  }
</style>
